import React, { useEffect, useState } from "react";
import SimpleTable from "../../components/simple-table";
import { Box, Divider, Flex, Tr, Td, Text } from "@chakra-ui/react";
import MiniSideBar from "../../components/mini-sidebar";
import Loader from "../../components/loader/loader";
import SecondaryNav from "../../components/seconday-nav";
import useLoader from "../../components/loader/loaderstates";
import { DropdownInput, PrimaryButton, PrimaryInput } from "../../components";
import { formatDate_Do_MMM_YYYY, getUniqueNames } from "../../auth";
import { FetchCurrentStockByPharmacy, FetchFilteredCurrentStockByPharmacy } from "../../middleware/services/currentstockbypharmacy";

const CurrentStockByPharmacy = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const [totalItemCount, setTotalItemCount] = useState(0);
  let itemPerPageCommonValue = 50;
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);
  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [currentPage, setCurrentPage] = useState(1);
  let [totalPages, setTotalPages] = useState(1);
  let [pageno, setPageno] = useState(1);
  const [data, setData] = useState([]);
  const [pharmacyNamesList, setPharmacyNamesList] = useState([]);
  const [selectedPharmacyName, setSelectedPharmacyName] = useState("");
  const [selectedPharmacyId, setSelectedPharmacyId] = useState(null);
  const [allPharmacies, setAllPharmacies] = useState([]);
  const [search, setSearch] = useState({
    medicineName: "",
    batchNumber: "",
    composition: "",
  });

  var pharmacyId = new URLSearchParams(window.location.search).get(
    "pharmacyid"
  );
  const fetchData = async () => {
    showLoader();
    let input = {
      pharmacyid: pharmacyId || null,
    };
    try {
      const result = await FetchCurrentStockByPharmacy(input);
      // console.log("result", result);
      if (result.result === "success") {
        setData(result?.data);
        setAllPharmacies(result.data);
        const filteredPharmacy = getUniqueNames(result?.data);
        setPharmacyNamesList(filteredPharmacy);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count);
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);
        setTotalPages(totalPagesCount);
        if (count < itemPerPageCommonValue) {
          setCountTo(count);
          setTotalExceedsPageCount(true);
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dismissLoader();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      getFilteredResults();
    }
  };

  const getFilteredResults = async () => {
    showLoader();
    let input = {
      medicinename: search.medicineName || null,
      batchnumber: search.batchNumber || null,
      chemicalcomposition: search.composition || null,
      pharmacyid: selectedPharmacyId || null,
      pageno: pageno,
      pagesize,
    };
    try {
      const result = await FetchFilteredCurrentStockByPharmacy(input);
      // console.log("result", result);
      if (result.result === "success") {
        setData(result?.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count);
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);
        setTotalPages(totalPagesCount);
        if (count < itemPerPageCommonValue) {
          setCountTo(count);
          setTotalExceedsPageCount(true);
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dismissLoader();
    }
  };

  const resetFeilds = () => {
    setSearch({
      medicineName: "",
      batchNumber: "",
      composition: "",
    });
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setSelectedPharmacyName("");
    setSelectedPharmacyId(null);
    fetchData()
  };

  useEffect(() => {
    fetchData();
  }, [pageno]);

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNextClick = () => {
    let page = pageno + 1;
    setPageno(page);
    setCurrentPage(currentPage + 1);
    if (countTo + pagesize < totalItemCount) {
      setCountTo(countTo + pagesize);
    } else {
      setCountTo(totalItemCount);
    }

    setCountFrom(countFrom + pagesize);
  };
  const handlePrevClick = () => {
    let page = pageno - 1;
    setPageno(page);
    setCurrentPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if (countTo == totalItemCount) {
      let updatedCountUnroundedValue = totalItemCount - pagesize;
      setCountTo(
        Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue) *
          itemPerPageCommonValue
      );
    } else {
      setCountTo(countTo - pagesize);
    }

    setCountFrom(countFrom - pagesize);
  };

  const TableHeader = [
    { key: "productname", label: "Medicine Name" },
    { key: "strength", label: "Strength" },
    { key: "batchnumber", label: "Batch Number" },
    { key: "expirydate", label: "Expiry Date" },
    { key: "remainingquantity", label: "Remaining Qty" },
    { key: "manufacturername", label: "Manufacturer" },
    { key: "pharmacyname", label: "Pharmacy Name" },
    // { key: "chemicalcomposition", label: "Chemical Composition" },
    // { key: "receiveddate", label: "Received Date" },
    // { key: "receivedby", label: "Received By" },
    // { key: "storagecondition", label: "Storage Condition" },
    // { key: "manufactureddate", label: "Manufactured Date" },
    // { key: "suppliername", label: "Supplier" },
    // { key: "supplierdate", label: "Supplier Date" },
    // { key: "costperunit", label: "Cost/Unit" },
    // { key: "costperstrip", label: "Cost/Strip" },
    // { key: "costperbox", label: "Cost/Box" },
    // { key: "cgst", label: "CGST (%)" },
    // { key: "sgst", label: "SGST (%)" },
    // { key: "createddate", label: "Created On" },
    // { key: "modifieddate", label: "Modified On" },
    // { key: "isactive", label: "Status" },
  ];

  function handlePharmacyNameChange(name) {
    setSelectedPharmacyName(name || "");
    const selected = allPharmacies.find(
      item => item.pharmacyname?.trim().toLowerCase() === (name || "").trim().toLowerCase()
    );
    if (selected) {
      setSelectedPharmacyId(selected.pharmacyid);
    } else {
      setSelectedPharmacyId(null);
    }
  }
  const gobackfunction = ()=>{
    window.history.back();
   }
  return (
    <>
      <Box w="100%">
        <Flex>
          <Box w="6rem">
            <MiniSideBar />
          </Box>
          {isLoading && <Loader />}
          <Box width="calc(100vw - 6.25rem)">
            <SecondaryNav withBack="Current Pharmacy Stock Report" goBack={gobackfunction} />
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="start"
              alignItems="center"
            >
              <PrimaryInput
                variant="fullRound"
                title="Medicine Name"
                inputPlace="Medicine Name"
                id="searchProductName"
                name="medicineName"
                inputValue={search.medicineName}
                onChange={handleFilterInputChange}
                onKeyDown={handleKeyDown}
              />

              <PrimaryInput
                variant="fullRound"
                title="Batch Number"
                inputPlace="Batch Number"
                id="searchBatchNumber"
                name="batchNumber"
                inputValue={search.batchNumber}
                onChange={handleFilterInputChange}
                onKeyDown={handleKeyDown}
              />

              <PrimaryInput
                variant="fullRound"
                title="Composition"
                inputPlace="Composition"
                id="searchComposition"
                name="composition"
                inputValue={search.composition}
                onChange={handleFilterInputChange}
                onKeyDown={handleKeyDown}
              />
              {!pharmacyId && (
                <DropdownInput
                  variant="fullSide"
                  dropDownPlace="Pharmacy Type"
                  options={pharmacyNamesList}       // array of strings
                  onClick={handlePharmacyNameChange}
                  value={selectedPharmacyName}
                  defaultOption={selectedPharmacyName || ""}
                />
               )}
              <PrimaryButton
                buttonText="Filter"
                id="filterButton"
                onClick={getFilteredResults}
                btnStyle={{ m: "0", w: "150px" }}
              />
              <PrimaryButton
                buttonText="Reset"
                id="resetButton"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                onClick={resetFeilds}
              />
            </Box>
            <Divider />
            {data && data.length > 0 ? (
              <>
                <Box
                  width="100%"
                  p="1rem"
                  overflow="hidden auto"
                  h="calc(100vh - 155px)"
                >
                  <SimpleTable
                    headers={TableHeader}
                    className="tableContainer"
                    isDataPresent={true}
                    // ref={tableRef}
                    footerStyle={{
                      pos: "fixed",
                      bottom: "0px",
                      left: "100px",
                      boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                    }}
                    tableStyle={{
                      maxH: "calc(100vh - 100px)",
                      overflowY: "auto",
                      tableLayout: "fixed",
                      width: "100%",
                      height: "calc(100% - 55px)"
                    }}
                    tableBody={
                      <>
                        {data.map((item, index) => (
                          <Tr w="100%" index={index}>
                            <Td display="flex" gap="0.5rem" alignItems="center">
                              <Text>{item.productname}</Text>
                              <Box
                                as="span"
                                bg="#E6E7E966"
                                mr="0.25rem"
                                border="1px solid #E6E7E9"
                                borderRadius="8px"
                                fontSize="10px"
                                px="8px"
                              >
                                {item.producttype}
                              </Box>
                            </Td>
                            <Td>
                              <Text>{item.dosage && item.dosageunit ? item.dosage + " " + item.dosageunit : "-"}</Text>
                            </Td>
                            <Td>
                              <Text>{item.batchnumber}</Text>
                            </Td>
                            <Td>
                              <Text>{item.expirydate}</Text>
                            </Td>
                            <Td>
                              <Text>{item.remainingquantity}</Text>
                            </Td>
                            <Td>
                              <Text>{item.manufacturername}</Text>
                            </Td>
                            <Td>
                              <Text>{item.pharmacyname}</Text>
                            </Td>
                          </Tr>
                        ))}
                      </>
                    }
                    footerSection={
                      <>
                        {data && data.length > 0 && (
                          <Tr w="100%">
                            <Td colSpan={11} w="calc(100vw - 6.5rem)">
                              <Box
                                w="100%"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Box
                                  visibility={
                                    totalItemCount < countTo &&
                                    !totalExceedsPageCount
                                      ? "hidden"
                                      : "visible"
                                  }
                                >
                                  <Text>
                                    Showing <b>{countFrom}</b> to{" "}
                                    {/* Showing <b>1</b> to <b>2</b> of 20 results */}
                                    <b>{countTo}</b> of {totalItemCount} results
                                  </Text>
                                </Box>

                                <Box
                                  gap="2.5rem"
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    as="button"
                                    onClick={handlePrevClick}
                                    disabled={currentPage == 1}
                                    visibility={
                                      currentPage == 1 ? "hidden" : "visible"
                                    }
                                    p="0.5rem 0.75rem"
                                    border="0.0625rem solid #E6E7E9"
                                    borderRadius="0.75rem"
                                    fontSize=".875rem"
                                    fontWeight="500"
                                  >
                                    Previous
                                  </Box>
                                  <Box>
                                    <Text
                                      textAlign="center"
                                      fontSize=".875rem"
                                      fontWeight="600"
                                    >
                                      Page {currentPage} of {totalPages}
                                      {/* Page 1 of 20 */}
                                    </Text>
                                  </Box>
                                  {totalItemCount >= countTo &&
                                    !totalExceedsPageCount && (
                                      <Box
                                        as="button"
                                        p="0.5rem 0.75rem"
                                        mr="2.5rem"
                                        border="0.0625rem solid #E6E7E9"
                                        borderRadius="0.75rem"
                                        onClick={handleNextClick}
                                        disabled={currentPage == totalPages}
                                        visibility={
                                          currentPage == totalPages
                                            ? "hidden"
                                            : "visible"
                                        }
                                        fontSize=".875rem"
                                        fontWeight="500"
                                      >
                                        Next
                                      </Box>
                                    )}
                                </Box>
                              </Box>
                            </Td>
                          </Tr>
                        )}
                      </>
                    }
                  />
                </Box>
              </>
            ) : (
              <Box width="100%">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  py="2rem"
                >
                  <Text fontSize="md" fontWeight="bold">
                    No Pharmacy Found
                  </Text>
                </Box>
              </Box>
            )}
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default CurrentStockByPharmacy;
